import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  IMessagesStateError,
  IMessagesStateSuccess,
  LeadModel,
} from '@boxx/messages-core';
import { Store } from '@ngrx/store';
import * as fromLeadsActions from '../actions/leads.actions';
import * as fromReducer from '../messages.reducer';
import * as fromLeadsSelector from '../selectors/leads.selectors';

@Injectable()
export class LeadsStore
  implements
    IStoreBase<LeadModel[], IMessagesStateSuccess, IMessagesStateError>
{
  constructor(public store: Store<fromReducer.MessagesState>) {}

  get state$() {
    return this.store.select(fromLeadsSelector.leadsState);
  }
  get data$() {
    return this.store.select(fromLeadsSelector.leadsData);
  }
  get loading$() {
    return this.store.select(fromLeadsSelector.leadsIsLoading);
  }
  get success$() {
    return this.store.select(fromLeadsSelector.leadsSuccess);
  }
  get error$() {
    return this.store.select(fromLeadsSelector.leadsError);
  }
  get fetched$() {
    return this.store.select(fromLeadsSelector.leadsHasBeenFetched);
  }

  fetch() {
    this.store.dispatch(fromLeadsActions.getLeadsBeginAction());
  }

  setAsRead(leadId: number) {
    this.store.dispatch(fromLeadsActions.setLeadAsReadBeginAction({ leadId }));
  }
}
